import React from "react";
import { useQuery } from "react-query";
import { useClient } from "../../../hooks";
import { Alert } from "reactstrap";
import { NotificationManager } from "react-notifications";
import { EditNote, Note } from "./components";
import { noop } from "lodash";

export const Notes = ({ application, allowChange, url, onChanged = noop }) => {
  const queryKey = [
    url,
    {
      params: {
        application,
      },
    },
  ];
  const client = useClient();
  const { data, refetch } = useQuery(queryKey, () =>
    client.get(...queryKey).get("data")
  );

  if (!data) return null;

  async function onSubmitNote(x) {
    const payload = {
      ...x,
      application,
    };
    await (!x.id
      ? client.post(url, payload)
      : client.put(`${url}/${x.id}`, payload));
    await refetch();
    NotificationManager.success("Note saved");
    onChanged();
  }

  async function onDeleteNote({ id }) {
    await client.delete(`${url}/${id}`);
    await refetch();
    NotificationManager.success("Note deleted");
    onChanged();
  }

  return (
    <div>
      {!data.length ? (
        <Alert color="info">No notes added to this application</Alert>
      ) : null}
      {data.map((i) => (
        <Note
          allowDelete={allowChange}
          value={i}
          key={i.id}
          onDelete={onDeleteNote}
        />
      ))}
      {allowChange ? (
        <EditNote defaultValues={{}} onSubmit={onSubmitNote} />
      ) : null}
    </div>
  );
};
